// --- WeeklyScheduleCalendar.js ---
import React from 'react';
import './WeeklyScheduleCalendar.css';

const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const WeeklyScheduleCalendar = ({ scheduledEvents = [] }) => {
  const groupedEvents = daysOfWeek.reduce((acc, day) => {
    acc[day] = [];
    return acc;
  }, {});

  scheduledEvents.forEach(event => {
    if (event.day && groupedEvents[event.day]) {
      groupedEvents[event.day].push(event);
    }
  });

  return (
    <div className="weekly-calendar">
      <h3 className="calendar-title">📆 Weekly View (Mon - Sun)</h3>
      <div className="calendar-grid">
        {daysOfWeek.map(day => (
          <div key={day} className="calendar-day">
            <h5 className="day-title">{day}</h5>
            {groupedEvents[day].length > 0 ? (
              groupedEvents[day].map((event, idx) => (
                <div key={idx} className="calendar-event">
                  <strong>{event.event_name}</strong><br />
                  {event.location}
                </div>
              ))
            ) : (
              <div className="no-events">No events</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeeklyScheduleCalendar;
